import { Component, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { NgxFileDropComponent, NgxFileDropEntry } from 'ngx-file-drop';
import { combineLatest, Observable } from 'rxjs';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';
import { CNDocumentFile } from 'src/app/models/cndocumentfile';
import { CNDocumentReport } from 'src/app/models/cndocumentreport';
import { CNReport } from 'src/app/models/cnreport';
import { ContactService } from 'src/app/services/contact.service';
import { DocumentsService, Template } from 'src/app/services/documents.service';
import { PatientService } from 'src/app/services/patient.service';

declare var Ext: any;

@Component({
  selector: 'app-contact-documents',
  templateUrl: './contact-documents.component.html',
  styleUrls: ['./contact-documents.component.scss']
})
export class ContactDocumentsComponent implements OnInit {

  @ViewChild('filedrop') filedrop: NgxFileDropComponent;

  @Output() documentAdded: CNDocumentReport | CNDocumentFile;

  public template: Template;
  public files: NgxFileDropEntry[] = [];
  public documents: CNDocumentReport[] = [];
  public contactType: CNConsultationType;

  private generating = false;
  private theContact: CNConsultation;

  constructor(private patient: PatientService, private contactSrv: ContactService,
              private ngZone: NgZone, private documentSrv: DocumentsService) { }

  ngOnInit(): void {
    this.contactSrv.saved.subscribe(savedConsultation => {
      if (this.generating) {
        this.contact = savedConsultation;
        this.openWindow();
        this.generating = false;
      }
      if (this.files.length !== 0) {
        this.contact = savedConsultation;
        this.sendFiles();
      }
    });
  }

  @Input() set contact(theContact: CNConsultation) {
    this.theContact = theContact;
    if (this.theContact) {
      if (this.theContact.getProperty('StVaast_Type')) {
        this.contactType = this.theContact.getProperty('StVaast_Type');
      } else {
        this.contactType = CNConsultationType.Simple;
      }
    }
    // Load contact documents
    this.loadDocuments();
  }

  get contact(): CNConsultation {
    return this.theContact;
  }

  loadDocuments(): void {
    this.contactSrv.documents(this.theContact).subscribe(documents => {
      this.documents = documents;
    });
  }

  selectTemplate(template: Template) {
    this.template = template;
  }

  generateDocument(): void {
    if (this.contact && this.contact.id === 0) {
      // Save document before
      this.generating = true;
      this.contactSrv.save(this.contact);
    } else {
      this.openWindow();
    }
  }

  openWindow(): void {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        // Open old report interface
        const documentWindow = new Ext.CNDocumentWindow({
          patientid: this.patient.patient.id,
          selectedTemplateId: this.template.templateid,
          selectedTemplateName: this.template.template,
          documentType: 'document',
          contactid: this.contact.id
        });
        documentWindow.on('documentSaved', () => {
          console.log('document saved');
          setTimeout(() => {
            this.loadDocuments();
          });
        });
        documentWindow.show();
      });
    });
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    if (this.contact && this.contact.id === 0) {
      // Save document before
      this.contactSrv.save(this.contact);
    } else {
      this.sendFiles();
    }
  }

  private sendFiles(): void {
    const sendingFilesObs: Observable<any>[] = [];
    for (const droppedFile of this.files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // Here you can access the real file
          console.log(droppedFile.relativePath, file);
          sendingFilesObs.push(this.documentSrv.storeFile(file, this.patient.patient, this.contact));
        });
      }
    }
    combineLatest(sendingFilesObs).subscribe(allFilesResults => {
      allFilesResults.forEach(storedDocument => {
      });
      this.files = [];
      setTimeout(() => {
        this.loadDocuments();
      });
    });
  }

  public fileOver(event){
    console.log(event);
  }

  public fileLeave(event){
    console.log(event);
  }

  openFileSelector() {
    this.filedrop.openFileSelector();
  }

  openDocument(document: CNDocumentReport | CNReport): void {
    const link = '/SN/StVaast/DocumentFile.php?reportid=' + document.id;
    window.open(link, '_report');
  }
}
